<!--商家中心-->
<template>
  <div class="mine-customer">
    <div>
      <van-notice-bar
      v-show="alert_str"
  left-icon="volume-o"
  :text="alert_str"
/>
      <div class="user-header">
        <img class="" style="position: fixed;top: 10px;left: 20px;width: 160px;" src="https://ccago.oss-cn-hangzhou.aliyuncs.com/editor/20220529/user-0/20220529/97f89c9abe0b1ef84e20d4bb8e1cb11c.png" alt="">
        <div class="user-message">
          <div class="user-detail">
            <div class="user-detail-right">
              <div class="user-name">{{row.XM_ZB}}（{{row.XM_BH}}）</div>
              <div style="color:#666; margin:0 0 6px 0">项目名称 <em style="color:#000">{{row.XM_MC}}</em></div>
              <div style="color:#666; margin:0 0 6px 0">开 发 商  <em style="color:#000" >{{row.XM_KFS}}</em></div>
              <div style="color:#666; margin:0 0 6px 0">项目地址 <em style="color:#000">{{row.XM_DZ}}</em>
              <button @click="toMap()" style="background:#1989fa; padding:0 6px; color:#fff;
                  border-radius: 10px;">地图导航</button> 
              </div>
              <div style="color:#666; margin:0 0 6px 0">设备厂商 <em style="color:#000">{{row.SBCS}}</em></div>
              <div class="user-invite" style="color:#666" @click="change">
                工地喷淋（{{row.XM_BH}}）
                <img src="../../../assets/images/weiyuanhui/icon-qiehuan.png" alt="">
                <span class="invite-num"  >[切换设备]</span>
              </div>
            </div>
            <div class="user-setting-box" @click="toBusinessSet">
              <img src="../../../assets/images/weiyuanhui/icon-seeting.png" alt="">
            </div>
          </div>
        </div>
        <div class="user-black flex-between"  @click="toWeiyuanhuiDetail">
          <div class="user-black-top">
            <div class="user-moneys">
              <div class="user-moneys-title">低水位报警</div>
              <div v-if="row.SWZT==1">水位正常</div>
              <div v-else >水位过低</div>
            </div>
            <div class="user-moneys" @click="toWeiyuanhuiDetail">
              <div class="user-moneys-title">喷淋状态</div>
              <div v-if="row.PLZT==1">喷淋中</div>
              <div v-else >停止中</div>
            </div>
          </div>
          <div class="user-black-middle"></div>
          <div class="user-black-top">
            <div class="user-moneys" @click="toWeiyuanhuiDetail">
              <div class="user-moneys-title">PM25浓度</div>
              <div>{{ row.PM25 }}<em>mg/m³</em></div>
            </div>
            <div class="user-moneys">
              <div class="user-moneys-title">PM10浓度</div>
              <div>{{ row.PM10 }}<em>mg/m³</em></div> 
            </div>
          </div>
        </div>
      </div>

      <div class="credit-box">
        <div class="credit-ul">
          <div class="credit-li">
            <span>{{ row['RUN_Info:nIa']/100 }}</span> <em>A</em> 
            <div class="credit-text">A相电流</div>
          </div>
          <div class="credit-li">
            <span>{{ row['RUN_Info:nIb']/100 }}</span> <em>A</em> 
            <div class="credit-text">B相电流</div>
          </div>
          <div class="credit-li">
            <span>{{ row['RUN_Info:nIc']/100 }}</span> <em>A</em> 
            <div class="credit-text">C相电流</div>
          </div>
        </div>
       <div class="credit-all">
         <div class="credit-all-left">
           低水位状态
           <span class="order-num" v-if=" row['RUN_Info:dsw_state']==0">
              低水位
             </span> 
             <span class="order-num" v-else >
              水位正常
             </span> 
         </div>
         <div class="credit-all-right">
           运行模式 
             
           <span class="order-num" v-if=" row['RUN_Info:YX_model']==0">
              手动
             </span> 
             <span class="order-num" v-else >
              自动
             </span>  
         </div>
       </div>
      </div>
           <div class="credit-box">
             <div class="credit-ul">
               <div class="credit-li">
                 <span>{{row['RUN_Info:PL_time']/10}} </span><em>s</em> 
                 <div class="credit-text">喷淋时长</div>
               </div>
               <div class="credit-li">
                 <span>{{row['RUN_Info:ZT_time']/10}} </span><em>s</em> 
                 <div class="credit-text">暂停时长</div>
               </div>
               <div class="credit-li">
                  <span>{{row['RUN_Info:QSFW_time']/10}} </span><em>s</em> 
                 <div class="credit-text">缺水复位时间</div>
               </div>
             </div>
             <!-- <div class="credit-all">
               <div class="credit-all-left">
                 累计收益 <span class="money-sym">¥</span><span class="credit-all-money">{{row.total_expect_profit/100}}</span>
               </div>
               <div class="credit-all-right">
                 累计订单<span class="order-num">{{row.total_order_count}}</span> 笔
               </div>
             </div> -->
           </div>
    </div>
    <div class="mini-nav">
      <ul>
        <li v-if="row['RUN_Info:YX_model']==1" @click="setStatus('Remote_config:WindSpeed',0)">
          <img src="../../../assets/images/weiyuanhui/icon-caipanyaunguanli.png" alt="">
          <p>模式设置<br/>(切换成手动)</p>
        </li>
        <li v-else @click="setStatus('Remote_config:WindSpeed',1)">
          <img src="../../../assets/images/weiyuanhui/icon-caipanyaunguanli.png" alt="">
          <p>模式设置<br/>(切换成自动)</p>
        </li>
        <li @click="setStatus('Remote_config:Reset',1)">
          <img src="../../../assets/images/weiyuanhui/icon-caipanyaunguanli.png" alt="">
          <p>报警复位</p>
        </li>
        <li @click="setStatus('Remote_config:Spray',1)" v-if="row['PLZT']==0">
          <img src="../../../assets/images/weiyuanhui/icon-caipanyaunguanli.png" alt="">
          <p>开启喷淋</p>
        </li>
        <li @click="setStatus('Remote_config:Spray',0)" v-else>
          <img src="../../../assets/images/weiyuanhui/icon-caipanyaunguanli.png" alt="">
          <p>关闭喷淋</p>
        </li>
        
        <li @click="toVideo()">
          <img src="../../../assets/images/weiyuanhui/icon-julebu.png" alt="">
          <p>监控视频</p>
        </li>
        <!-- <li @click="toDetail('WyhSihaoList')">
          <img src="../../../assets/images/weiyuanhui/icon-sihaoyundongyaun.png" alt="">
          <p>四好运动员</p>
        </li>
        <li @click="toDetail('WyhHuiyiApplyList')">
          <img src="../../../assets/images/weiyuanhui/icon-huiyi.png" alt="">
          <p>会议</p>
        </li>
        <li @click="toDetail('WyhJiaolianList')">
          <img src="../../../assets/images/weiyuanhui/icon-jiaolianyuanguanli.png" alt="">
          <p>教练员管理</p>
        </li>
        <li @click="toDetail('WyhCaipanList')">
          <img src="../../../assets/images/weiyuanhui/icon-caipanyaunguanli.png" alt="">
          <p>裁判员管理</p>
        </li>
        <li @click="toDetail('WyhSaiApplyList')">
          <img src="../../../assets/images/weiyuanhui/icon-saishi.png" alt="">
          <p>赛事</p>
        </li>
        <li @click="toDetail('WyhOrderList')">
          <img src="../../../assets/images/weiyuanhui/icon-customerorder.png" alt="">
          <p>客户订单管理</p>
        </li>
        <li @click="toDetail('WyhConfigureList')">
          <img src="../../../assets/images/weiyuanhui/icon-sellrorder.png" alt="">
          <p>销售单管理</p>
        </li> -->
      </ul>
    </div>

    <LoginDialog :show="loginShow" @loginSuccess="loginSuccess" @loginCancel="loginCancel"/>
  </div>
</template>
<style src="../../../assets/style/weiyuanhui.css" scoped></style>
<style scoped>
.user-black {
  height: 1.2rem;
}
.user-black-top em{
  font-size: 12px;
  color: #999;
}
.credit-li em{
  font-size: 12px;
  color: #999;
}

.business-setting-img img {
  width: 66px;
  position: fixed;
  right: 1.2rem;
  bottom: 3.5rem;
  z-index: 10;
}

.mine-customer {
  overflow: auto;
  height: 100%;
  background: #f8f8f8;
}

.user-setting-box {
  position: absolute;
  right: 0;
  top: 0;
}

.user-invite img {
  width: 12px;
  height: 12px;
}

.invite-num {
  font-size: 12px;
  color: #666;
  font-family: PingFangSC-Regular, PingFang SC;
}

.user-header {
  background: url('../../../assets/images/weiyuanhui/icon-bg.png') no-repeat;
  background-size: 7.5rem 2.8rem;
}

.two-back {
  background: #73b7d0;
}
</style>

<script>
// import BusinessNavDialog from '@/components/business/BusinessNavDialog.vue';
import LoginDialog from '@/components/LoginDialog.vue';
import {Toast} from "vant";

export default {
  name: 'WeiyuanhuiIndex',
  components: {
    // BusinessNavDialog
    LoginDialog
  },
  data: function () {
    return {
      device:'',
      row: [],
      id: 0,
      navShow: false,
      loginShow: false,
      alert_list:[],
      alert_str :'',
    }
  },
  filter: {},
  mounted() {
    document.title = "设备详情"
    let weiyuanhui_id = this.id = this.$route.query.weiyuanhui_id
    this.device =  this.$route.query.device
    if (weiyuanhui_id) {
      localStorage.setItem('_business_id', weiyuanhui_id)
    } else {
    }
      this.getDetail();
      this.getAlert();
    setInterval(() =>{
      this.getDetail();
      this.getAlert();
    },5000) 

  },
  destroyed() {
  },
  methods: {
    toDetail(name) {
      // this.$router.push({name: name})
      rbLink({name: name})
    },

    getDetail() {
      let that = this;
      that.$api.get('/api/test/getdata', {device: that.device}, (res) => {
        that.row = res.data
      }, (res) => {
        if (res.code == 401 || res.code == 402) {
          that.loginShow = true
        } else {
          Toast(res.msg)
        }
      })
    },

    getAlert() {
      let that = this;
      that.$api.get('/api/test/alertList', {device: that.device}, (res) => {
        that.alert_list = res.data 
        that.alert_str = '';
        that.alert_list.map(item =>{
          that.alert_str += item.Name + ' '+item.time_str +'。  ';
        })
      }, (res) => {
        if (res.code == 401 || res.code == 402) {
          that.loginShow = true
        } else {
          Toast(res.msg)
        }
      })
    },
    setStatus(name,status){
      let that = this;
      console.log(that.row['RUN_Info:YX_model']);
      // return ;
      if(name=='Remote_config:Reset' && that.alert_list.length==0){
          Toast('必须报警状态下才可以操作')
          return ;
      }
      if(that.row['RUN_Info:YX_model'] ==1 && name=='Remote_config:Spray'){
          Toast('必须是手动模式下才可以操作')
          return ;
      }
      that.$api.post('/api/test/setstatus', {
        name,
        status,
        device: that.device
      }, (res) => {
          Toast('设置成功')
          that.getWyhDetail();
      }, (res) => {
          Toast(res.msg)
      })
    },  

    toBusinessSet() {
      Toast('更多功能，即将开放')
      return ;
      let that = this;
      rbLink({
        name: 'SiteSettingIndex'
      })
      // that.$router.push({
      //     name: 'SiteSettingIndex'
      // })
    },
    change(){
      if(this.device =='2019G65-01'){ 
        location.href = '/cca-h5/dist/devicetest?device=G27-01'
      }else{
        console.log('G27-01')
        location.href = '/cca-h5/dist/devicetest?device=2019G65-01'
      }
    },
    toVideo(){
      if( this.device == 'G27-01'){
              location.href='https://open.ys7.com/jssdk/theme/h5/live.html?deviceSerial=J80620690&channelNo=1&accessToken=at.9h0vnmsnaukmwmr84j87ggf21ydlqgl8-2vds77rkdv-0kdjtdf-uzb2u1joc&validCode=';
      }else{
             location.href='https://open.ys7.com/jssdk/theme/h5/live.html?deviceSerial=J80620673&channelNo=1&accessToken=at.9h0vnmsnaukmwmr84j87ggf21ydlqgl8-2vds77rkdv-0kdjtdf-uzb2u1joc&validCode=';
      }
    },
    toWeiyuanhuiDetail() {
      let that = this;
      rbLink({
        name: 'WeiyuanhuiDetail'
      })
    },
    toMap(){
      Toast('即将开放')
      return ;
    },
    loginSuccess(res) {
      console.log('-------登录成功--------', res);
      this.loginShow = false;
      this.getWyhDetail()
    },

    loginCancel() {
      console.log('-------取消登录--------');
      // this.loginShow = false;
    },
  }
}
</script>



// WEBPACK FOOTER //
// Devicetest.vue?720225ae